import { render, staticRenderFns } from "./GradeRatePie.vue?vue&type=template&id=125f77f4&scoped=true&"
import script from "./GradeRatePie.vue?vue&type=script&lang=js&"
export * from "./GradeRatePie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f77f4",
  null
  
)

export default component.exports